exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.uploader {\n    width: 100%;\n    height: 150px;\n    text-align: center;\n}\nimg.uploaded-img {\n    width: 100%;\n    height: 100%;\n    border-radius: 4px;\n    border: 1px solid #ccc;\n    -o-object-fit: contain;\n       object-fit: contain;\n}\n.button.add-btn {\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    font-size: 18px;\n}\n.button.delete-btn {\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: #00000054;\n    color: #fff;\n    font-size: 18px;\n    font-weight: bold;\n}\n\n", ""]);

// exports
